/* eslint-disable react/display-name */
import React, { lazy, useEffect } from 'react'
import Sidebar from './Sidebar'
import { sn_url } from '../../utils/js/endpoints'
import { TabsAndPages } from '../../components/tabs_and_pages/TabsAndPages.js'
import Feedback from '../../components/feedback/Feedback'
import SuspenseLoader from '../../components/suspense_loader/SuspenseLoader'

import './TradeSigningsTracker.scss'
import HeaderTitle from '../shared/HeaderTitle'
import { isHeader } from '../../utils/js/browser_helpers'

const TradeTracker = lazy(() => import('./pages/TradeTracker'))
const SigningsTracker = lazy(() => import('./pages/SigningsTracker'))

export default function TradeSigningsTracker(props) {
    const { sport, league, page } = props.match.params

    let tabsAndPageData = generateLinkingTabData(sport, league, page)
    let activeIndex = tabsAndPageData.findIndex(item => item.active)

    useEffect(() => {
        if (activeIndex === 0 && window.adUtility) {
            window.adTargets = function() {
                return {
                    section: 'hockey',
                    page: 'hockey,nhl,trade-tracker',
                    ad_unit_path: 'en.sportsnet.web/hockey/nhl',
                    Tags: ['BET365'],
                }
            }
            window.adUnitPath = '/7326/' + window.adTargets().ad_unit_path
            if (window.location.search.indexOf('template') === 1) {
                window.adTargets = function() {
                    return {
                        section: 'hockey',
                        page: 'hockey,nhl,trade-tracker',
                        ad_unit_path: 'en.sportsnet.app/hockey/nhl',
                        Tags: ['BET365'],
                    }
                }
                window.adUnitPath = '/7326/' + window.adTargets().ad_unit_path
                window.adUtility.insertAd('trade-tracker-sponsor', {
                    type: window.adUtility._AD_SPONSORSHIP_BUTTON,
                    adPath: window.adUnitPath,
                    targeting: window.adTargets(),
                })
            } else {
                window.adUtility.insertAd('trade-tracker-sponsor', {
                    type: window.adUtility._AD_SPONSORSHIP_BUTTON,
                    adPath: window.adUnitPath,
                    targeting: window.adTargets(),
                })
            }
        }
    }, [activeIndex])

    return (
        <div className="TradeSigningsTracker__cont">
            <div className="page_title_cont">
                <div className="left_col">
                    <HeaderTitle
                        title={'Signings & Trades'}
                        isHeader={isHeader}
                        allowDarkMode
                        showSponsorbadge={false}
                    />
                    {activeIndex === 0 ? (
                        <div className="trade-tracker-sponsor" id="trade-tracker-sponsor" />
                    ) : null}
                </div>
                <div className="right_col"></div>
            </div>
            <div className="inner_cont">
                <div className="left_col">
                    <TabsAndPages
                        initStateData={{
                            activeIndex: activeIndex,
                            endpointData: {},
                            initLoad: true,
                        }}
                        pageData={tabsAndPageData}
                    />
                </div>

                <div className="right_col">
                    <Sidebar league={league} />
                </div>
            </div>
            <Feedback formId="14759" />
        </div>
    )
}

const generateLinkingTabData = (sport = '', league = '', page = '') => {
    if (!sport || !league || !page) return []

    return [
        {
            display_name: 'Trades',
            page: 'trade-tracker',
            sport: sport,
            league: league,
            active: page === 'trade-tracker',
            show_tab: true,
            init_endpoint: sn_url + `/wp-json/sportsnet/v1/trade-tracker`,
            component: props => {
                if (props.isFetching) return <SuspenseLoader />
                return <TradeTracker league={league} sport={sport} {...props} />
            },
        },
        {
            display_name: 'Signings',
            page: 'signings',
            sport: sport,
            league: league,
            active: page === 'signings',
            show_tab: true,
            init_endpoint: sn_url + `/wp-json/sportsnet/v1/signings-tracker`,
            component: props => {
                if (props.isFetching) return <SuspenseLoader />
                return <SigningsTracker league={league} sport={sport} {...props} />
            },
        },
    ]
}
